<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <Field
      v-slot="{ field, errors }"
      v-model="optionalInformationStore.qualifications_description"
      name="qualifications_description"
    >
      <div class="input-group row pe-0">
        <div class="col-12 pe-0">
          <label class="form-label size-12" for="">資格</label>
          <textarea
            class="form-control bg-silver-primary input-primary size-14 border-0"
            rows="5"
            placeholder="取得した資格などあればご入力ください。"
            v-bind="field"
            :class="{ 'is-invalid': !!errors.length }"
          ></textarea>
          <div
            class="d-flex justify-content-end mt-2 size-10"
            :class="
              optionalInformationStore.qualifications_description?.length > 500
                ? 'text-danger'
                : 'text-black-50'
            "
          >
            {{ optionalInformationStore.qualifications_description?.length || 0 }}
            /500（最大文字数500文字）
          </div>
          <ErrorMessage name="qualifications_description" class="invalid-feedback" />
        </div>
      </div>
    </Field>
  </div>
</template>

<script setup lang="ts">
import { Field, ErrorMessage } from 'vee-validate';
import { useOptionalInformationStore } from '@/stores/resume-candidate/OptionalInformation.store';

const optionalInformationStore = useOptionalInformationStore();
</script>
